export enum VerificationStepType {
    DOCUMENT_CHOICE = "document_choice",
    CONSENT = "consent",
    DOC_FRONT = "doc_front",
    DOC_BACK = "doc_back",
    DOC_NFC = "doc_nfc",
    SELFIE = "selfie",
    LIVENESS = "liveness",
    INFORMATION = "information",
    IDV_VERIFICATION = "idv_verification",
}

export const convertStringIntoVerificationStepType = (value: string): VerificationStepType => {
    const enumValue = Object.keys(VerificationStepType).find(key => key === value)
    if (enumValue) {
        return enumValue as VerificationStepType
    }
    throw new Error()
}